import { Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import {
  ClientContactShareDTO,
  LogAction,
  LogContextType,
  LogEntityType,
  saveActivityLog,
} from 'wisestep-api';
import { ScrollableTabs } from 'wisestep-base';

import { activityLogDTOHelper } from '../../../../features/activityLog/ActivityHelper';
import {
  getActiveWorkspaceUsers,
  getClientContactActiveWorkspaceUsers,
} from '../../../../features/users/helper/hooks';

import AssignedClientUser from './AssignedClientUser';
import ClientUserList from './ClientUserList';

export interface IRecruitersTableProps {
  clientId: string;
  moduleName: string;
  clientContactId?: string;
}

const ClientSharingTable = ({ clientId, moduleName, clientContactId }: IRecruitersTableProps) => {
  const methods = useForm();

  const [tabPanelPage, setTabPanelPage] = useState(0);
  const [refresh, setRefresh] = useState<boolean>(false);
  const [assignedUsers, setAssignedUser] = useState<string[]>();

  useEffect(() => {
    const getWorkAssignments = async () => {
      if (moduleName == 'CLIENT') {
        setAssignedUser(await getActiveWorkspaceUsers(clientId));
      } else {
        const clientShareDTO: ClientContactShareDTO = {
          clientId: clientId,
          clientContactId: clientContactId ?? '',
        };
        const response = await getClientContactActiveWorkspaceUsers(clientShareDTO);
        setAssignedUser(response);
      }
    };
    getWorkAssignments();
  }, [clientContactId, clientId, moduleName, refresh]);

  const onAssign = async (list: string[], idNameMap: { email?: string; name?: string }) => {
    setRefresh(!refresh);
    setTabPanelPage(1);
    let type = '';
    if (tabPanelPage === 0) {
      type = 'ASSIGNED';
    } else {
      type = 'UNASSIGNED';
    }
    if (type !== '') {
      let assignedUserList = '';
      list?.map((user) => {
        assignedUserList += `${assignedUserList !== '' ? ', ' : ''}${idNameMap[user]} ${user}`;
      });
      let fieldName = 'Client Access';
      if (moduleName != 'CLIENT') {
        fieldName = 'Client Contact Access';
      }
      const avPayload = { ...activityLogDTOHelper };
      avPayload.action = type === 'ASSIGNED' ? LogAction.Assigned : LogAction.UnAssigned;
      const typeName = type === 'ASSIGNED' ? 'Assigned' : 'UnAssigned';
      const description = `${typeName} ${assignedUserList} ${type === 'ASSIGNED' ? 'to' : 'from'}`;
      avPayload.description = description;
      avPayload.entityType = LogEntityType.Client;
      avPayload.parentEntitiyType = LogContextType.Client;
      avPayload.parentEntitiyId = clientId as string;
      avPayload.field = fieldName;
      avPayload.contextData = { clientId: clientId };
      await saveActivityLog(avPayload);
    }
  };

  return (
    <>
      <FormProvider {...methods}>
        <ScrollableTabs
          scrollList={[
            { tabName: 'Not Assigned' },
            {
              tabName: 'Assigned',
              tabCount: assignedUsers?.length ?? 0,
            },
          ]}
          getTabIndex={setTabPanelPage}
          defaultValue={tabPanelPage}
        />
        {tabPanelPage === 0 && (
          <Grid container p={3} mb={5}>
            <ClientUserList
              clientIds={[clientId]}
              clientContactIds={[clientContactId ?? '']}
              onAssign={onAssign}
              assignedUsers={assignedUsers}
              moduleName={moduleName}
            />
          </Grid>
        )}
        {tabPanelPage === 1 && (
          <Grid container p={2}>
            <AssignedClientUser
              clientId={clientId}
              clientContactId={clientContactId}
              onAssign={onAssign}
              assignedUsersList={assignedUsers}
              moduleName={moduleName}
            />
          </Grid>
        )}
      </FormProvider>
    </>
  );
};

export default ClientSharingTable;
